export const setShopReducer = (shopData) => {
    return {
        type: 'SET_SHOP_DATA',
        payload: shopData,
    };
};

export const setBasketReducer = (basketData) => {
    return {
        type: 'SET_BASKET_DATA',
        payload: basketData,
    };
};

export const setBasketCloneReducer = (basketData) => {
    return {
        type: 'SET_BASKETCLONE_DATA',
        payload: basketData,
    };
};

export const updateItemCountBasketClone = (itemId, newCount) => {
    return {
        type: 'UPDATE_ITEM_COUNT_BASKETCLONE',
        payload: { itemId, newCount }
    };
};

export const removeItemBasketClone = (itemId) => {
    return {
        type: 'REMOVE_ITEM_BASKETCLONE',
        payload: itemId
    };
};

export const updateItemCountBasket = (itemId, newCount) => {
    return {
        type: 'UPDATE_ITEM_COUNT_BASKET',
        payload: { itemId, newCount }
    };
};

export const updateItemDataBasket = (itemId, newItem) => {
    return {
        type: 'UPDATE_ITEM_DATA_BASKET',
        payload: { itemId, newItem }
    };
};

export const updateItemHidedDataBasket = (itemId, hided) => {
    return {
        type: 'UPDATE_ITEM_HIDED_DATA_BASKET',
        payload: { itemId, hided }
    };
};

export const updateItemCostBasket = (itemId, newCost) => {
    return {
        type: 'UPDATE_ITEM_COST_BASKET',
        payload: { itemId, newCost }
    };
};

export const updateItemCostBasketClone = (itemId, newCost) => {
    return {
        type: 'UPDATE_ITEM_COST_BASKETCLONE',
        payload: { itemId, newCost }
    };
};

export const updateItemCommentBasketClone = (itemId, newComment) => {
    return {
        type: 'UPDATE_ITEM_COMMENT_BASKETCLONE',
        payload: { itemId, newComment }
    };
}

export const removeItemBasket = (itemId) => {
    return {
        type: 'REMOVE_ITEM_BASKET',
        payload: itemId
    };
};

export const addItemToBasket = (newItem) => {
    return {
        type: 'ADD_ITEM_TO_BASKET',
        payload: newItem
    };
};

export const addItemToBasketClone = (newItem) => {
    return {
        type: 'ADD_ITEM_TO_BASKETCLONE',
        payload: newItem
    };
}

export const setCategories = (categoriesList) => {
    return {
        type: 'SET_CATEGORIES_DATA',
        payload: categoriesList
    };
};

export const updateSettingsCounts = (newSettings) => ({
    type: 'UPDATE_SETTINGS',
    payload: newSettings,
});

const initialState = {
    shop: {},
    basket: [],
    basketClone: [],
    categories: {},
};

const shopReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SHOP_DATA':
            return {
                ...state,
                shop: action.payload,
            };
        case 'SET_BASKET_DATA':
            return {
                ...state,
                basket: Object.values([action.payload][0]),
            };
        case 'SET_BASKETCLONE_DATA':
            return {
                ...state,
                basketClone: Object.values(action.payload),
            };
        case 'SET_CATEGORIES_DATA':
            return {
                ...state,
                categories: action.payload,
            };
        case 'UPDATE_SETTINGS':
            return {
                ...state,
                shop: {
                    ...state.shop,
                    settings: {
                        ...state.shop.settings,
                        ...action.payload,
                    },
                },
            }
        case 'UPDATE_ITEM_COUNT_BASKET':
            return {
                ...state,
                basket: Object.values(state.basket).map(item =>
                    item.id === action.payload.itemId ? { ...item, count: action.payload.newCount } : item
                )
            };
        case 'UPDATE_ITEM_COUNT_BASKETCLONE':
            return {
                ...state,
                basketClone: Object.values(state.basketClone).map(item =>
                    item.id === action.payload.itemId ? { ...item, count: action.payload.newCount } : item
                )
            };
        case 'UPDATE_ITEM_DATA_BASKET':
            return {
                ...state,
                basket: Object.values(state.basket).map(item => {
                    return item.item_id === action.payload.newItem.item_id
                        ? { ...item, ...action.payload.newItem }
                        : item
                })
            };
        case 'UPDATE_ITEM_HIDED_DATA_BASKET':
            return {
                ...state,
                basket: Object.values(state.basket).map(item =>
                    item.item_id === action.payload.itemId ? { ...item, hided: action.payload.hided } : item
                )
            };
        case 'UPDATE_ITEM_COST_BASKET':
            return {
                ...state,
                basket: Object.values(state.basket).map(item =>
                    item.id === action.payload.itemId ? { ...item, cost: action.payload.newCost } : item
                )
            };
        case 'UPDATE_ITEM_COST_BASKETCLONE':
            return {
                ...state,
                basketClone: Object.values(state.basketClone).map(item =>
                    item.id === action.payload.itemId ? { ...item, cost: action.payload.newCost } : item
                )
            };
        case 'UPDATE_ITEM_COMMENT_BASKETCLONE':
            return {
                ...state,
                basketClone: Object.values(state.basketClone).map(item =>
                    item.id === action.payload.itemId ? { ...item, comment: action.payload.newComment } : item
                )
            };
        case 'REMOVE_ITEM_BASKET':
            return {
                ...state,
                basket: Object.values(state.basket).filter(item => item.id !== action.payload)
            };
        case 'REMOVE_ITEM_BASKETCLONE':
            return {
                ...state,
                basketClone: Object.values(state.basketClone).filter(item => item.id !== action.payload)
            };
        case 'ADD_ITEM_TO_BASKET':
            return {
                ...state,
                basket: [
                    ...state.basket,
                    action.payload
                ]
            };
        case 'ADD_ITEM_TO_BASKETCLONE':
            return {
                ...state,
                basketClone: [
                    ...state.basketClone,
                    action.payload
                ]
            };
        default:
            return state;
    }
};

export default shopReducer;
